import OrdersTable from "./components/OrdersTable";

const Tables = () => {
  return (
    <div>
      <div className="f mt-5 h-full w-full">
        <OrdersTable />
      </div>
    </div>
  );
};

export default Tables;
